<template>
  <wc-dialog
    :title="'Journal Entry #' + journalEntry.id"
    :showDialog='showDialog'
    hideCancel
    @save="$emit('close')"
    saveText='Close'
    width='900'
  >
    <template v-slot:dialog-form>
      <v-card-text>
        <v-row dense>
          <v-col>
            <p class='grey--text'>{{ journalEntry.posting_date | shortDate }}</p>
          </v-col>
          <v-col class='text-right'>
            <v-chip v-if='journalEntry.reversing_entry' small outlined color='warning'>Reversing</v-chip>
          </v-col>
        </v-row>
        <span>
          <strong>Reason: </strong><br>{{ journalEntry.description }}
        </span>
      </v-card-text>
      <br>
      <v-divider></v-divider>
      <v-simple-table dense v-if='journalEntry'>
        <thead>
          <tr>
            <th>Account</th>
            <th>Description</th>
            <th :width='amountWidth'>Inv/Exp</th>
            <th :width='amountWidth' class='text-right'>Debit</th>
            <th :width='amountWidth' class='text-right'>Credit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for='l in lines' :key='l.id' :class="l.account === highlightAccount ? 'blue lighten-4' : ''">
            <td>{{ l.account_data.name }}</td>
            <td>{{ l.description }}</td>
            <td>
              <a v-if='l.invoice' @click='openInvoice(l.invoice)'>Inv</a>
              <a v-if='l.expense' @click='openExpense(l.expense)'>Exp</a>
            </td>
            <td align='right'>{{ getAmountDisplay(l.debit) }}</td>
            <td align='right'>{{ getAmountDisplay(l.credit) }}</td>
          </tr>
          <tr>
            <td style='border-top: solid 1px black'></td>
            <td style='border-top: solid 1px black'></td>
            <td style='border-top: solid 1px black'></td>
            <td style='border-top: solid 1px black' class='font-weight-bold' align='right'>{{ getAmountDisplay(totalJEDebits) }}</td>
            <td style='border-top: solid 1px black' class='font-weight-bold' align='right'>{{ getAmountDisplay(totalJECredits) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>

    <template v-slot:dialog-actions>
      <v-btn
        :disabled='!journalEntry.can_edit'
        small
        depressed
        color='error'
        @click='openJE'
      >
        Edit Journal Entry
      </v-btn>
    </template>
  </wc-dialog>
</template>

<script>
import _ from 'lodash'
import miscServices from '@/services/misc'

export default {
  name: 'je-dialog',
  props: {
    showDialog: {
      required: true
    },
    journalEntry: {
      required: true
    },
    lines: {
      required: true
    },
    highlightAccount: {
      required: false
    }
  },
  data: () => ({
    amountWidth: 120
  }),
  computed: {
    totalJEDebits () {
      if (this.journalEntry) {
        return _.sumBy(this.lines, 'debit')
      }
      return 0
    },
    totalJECredits () {
      if (this.journalEntry) {
        return _.sumBy(this.lines, 'credit')
      }
      return 0
    },
  },
  watch: {
    showDialog(visible) {
      if (visible) {
        // Here you would put something to happen when dialog opens up
        console.log((this.lines))
        console.log("Dialog was opened!")
      } else {
        console.log("Dialog was closed!")
      }
    }
  },
  methods: {
    getAmountDisplay (amt) {
      return amt ? this.$options.filters.decAccounting(amt) : '-'
    },
    openInvoice (invID) {
      miscServices.openInNewTab({ name: 'InvoiceOverview', params: { id: invID } })
    },
    openExpense (expID) {
      miscServices.openInNewTab({ name: 'ExpenseOverview', params: { id: expID } })
    },
    openJE () {
      miscServices.openInNewTab({ name: 'JournalEntry', params: { id: this.journalEntry.id } })
    }
  }
}
</script>
